import { render } from "./CardPreviewContainer.vue?vue&type=template&id=abfa763a&scoped=true"
import script from "./CardPreviewContainer.vue?vue&type=script&lang=js"
export * from "./CardPreviewContainer.vue?vue&type=script&lang=js"

import "./CardPreviewContainer.vue?vue&type=style&index=0&id=abfa763a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-abfa763a"

export default script